import {ChangeDetectorRef, Component} from '@angular/core';
import {NavController} from 'ionic-angular';

import {Data} from '../../providers/providers';

import {LoginPage} from '../login/login';
import {SignupPage} from '../signup/signup';

import {AngularFireAuth} from 'angularfire2/auth';
import {LocationListPage} from "../location-list/location-list";
import {PrivacyPage} from "../privacy/privacy";
import {SupportPage} from "../support/support";
import {PasswordResetPage} from "../password-reset/password-reset";

// TEMP
import {Thinning} from '../../providers/providers';
import {Location} from '../../models/location';
import {ThinningDataset} from '../../models/thinning-dataset';
import {ThinningMeasurementDetailPage} from "../thinning-measurement-detail/thinning-measurement-detail";
import {LocationDetailPage} from "../location-detail/location-detail";
import {ThinningDatasetDetailPage} from "../thinning-dataset-detail/thinning-dataset-detail";
import {first, map} from "rxjs/operators";

import firebase from 'firebase/app'
import 'firebase/firestore'
import * as _ from 'lodash'

/**
 * The Welcome Page is a splash page that quickly describes the app,
 * and then directs the user to create an account or log in.
 * If you'd like to immediately put the user onto a login/signup page,
 * we recommend not using the Welcome page.
 */
@Component({
    selector: 'page-welcome',
    templateUrl: 'welcome.html'
})
export class WelcomePage {

    constructor(public navCtrl: NavController,
                private firebaseAuth: AngularFireAuth,
                public data: Data,
                public thinning: Thinning) { // TEMP
    }

    ionViewDidLoad() {

        // Handle a login event, whether from login form or auto-login based on a locally stored firebase session.
        // This is initiated here because we need access to the NavController; other init functions are handled by
        // the data class.
        this.firebaseAuth.authState.subscribe(user => {
            console.log('auth user', user);
            if (user && user.email) {
                this.data.handleUserAuthentication(user);
                this.navCtrl.setRoot(LocationListPage);

                // this.tempJumpToMeasurements();
                // this.tempGetAllLocations();

            }
        });

    }

    login() {
        this.navCtrl.push(LoginPage);
    }

    signup() {
        this.navCtrl.push(SignupPage);
    }

    resetPassword() {
        this.navCtrl.push(PasswordResetPage, {});
    }

    openPrivacy() {
        this.navCtrl.push(PrivacyPage, {});
    }

    openSupport() {
        this.navCtrl.push(SupportPage, {});
    }

    tempJumpToMeasurements() {
        // TEMP - go straight to measurements form for faster debugging

        // this.firebaseAuth.auth.signInWithEmailAndPassword('test@example.com', 'test123').then(value => {

        // const location = this.data.afs.doc('locations/test@example.com/locations/-L3VxLL2tL8O9KuMZuuB');
        // const dataset = this.data.afs.doc('thinning_datasets/test@example.com/thinning_datasets/-L3VxLL2tL8O9KuMZuuB');
        // const measurement = this.data.afs.doc('thinning_datasets/test@example.com/thinning_datasets/-L3VxLL2tL8O9KuMZuuB/measurements/2017-05-31');

        // location.valueChanges().subscribe((loc: Location) => {
        //     dataset.valueChanges().subscribe((ds: ThinningDataset) => {
        //         this.thinning.setDataset(ds, loc);
        //
        //             this.navCtrl.push(ThinningDatasetDetailPage, {
        //                 dataset: ds,
        //                 location: loc
        //             });
        //
        //         measurement.valueChanges().subscribe((meas) => {
        //             console.log(meas);
        //             this.navCtrl.push(ThinningMeasurementDetailPage, {
        //                 dataset: ds,
        //                 location: loc,
        //                 measurement: meas
        //             });
        //         });
        // });
        // });
        // });
    }

    tempGetAllLocations() {
        // const db = firebase.firestore()
        //
        // const USERS = [
        //     'Aaron@Railsideorchardsinc.com',
        //     'Brian@BeechCreekOrchards.com',
        //     'Judy@schwalliers.com',
        //     'Rileybruce44@gmail.com',
        //     'agjurgens@yahoo.com',
        //     'anl2@cornell.edu',
        //     'applesecker@gmail.com',
        //     'atucha@wisc.edu',
        //     'bostonhillfarm@verizon.net',
        //     'brunocarra@hotmail.com',
        //     'bsorchards@gmail.com',
        //     'canterlynn@gmail.com',
        //     'chazyorchards@westelcom.com',
        //     'chelcie@honeypothill.com',
        //     'cherrylawnfarm@gmail.com',
        //     'chrisnr50@gmail.com',
        //     'cowhersr1@gmail.com',
        //     'curtis@verdantrobotics.com',
        //     'dalerow06@gmail.com',
        //     'danny@cristapples.com',
        //     'david@bittnersingerorchards.com',
        //     'david@singerfarms.com',
        //     'dcooley@umass.edu',
        //     'dda42@cornell.com',
        //     'dda42@cornell.edu',
        //     'dda@cornell.edu',
        //     'dean@berrypatchfarm.com',
        //     'djd13@cornell.edu',
        //     'djtower2@yahoo.com',
        //     'dlo6@cornell.edu',
        //     'dlo778413@gmail.com',
        //     'doyon132@hotmail.com',
        //     'foo@bar.com',
        //     'fourni49@msu.edu',
        //     'gac_gloria@hotmail.com',
        //     'gareginat@uchile.cl',
        //     'gebbersmr@gebbersfarms.com',
        //     'gmp32@cornell.edu',
        //     'grower@orchardco.com',
        //     'guimesander@hotmail.com',
        //     'hbrooks1935@yahoo.com',
        //     'hwcleland@gmail.com',
        //     'jameszingler@yahoo.com',
        //     'gareginat@uchile.cl',
        //     'gebbersmr@gebbersfarms.com',
        //     'gmp32@cornell.edu',
        //     'grower@orchardco.com',
        //     'guimesander@hotmail.com',
        //     'hbrooks1935@yahoo.com',
        //     'hwcleland@gmail.com',
        //     'jameszingler@yahoo.com',
        //     'jamiek@riveridgeproduce.com',
        //     'jaumelordan@gmail.com',
        //     'jcline@uoguelph.ca',
        //     'jec3@cornell.edu',
        //     'jekyll6614@gmail.com',
        //     'jennyhiswife@gmail.com',
        //     'jim@bittnersingerorchards.com',
        //     'jl3325@cornell.edu',
        //     'jmcextman@gmail.com',
        //     'joafrcar@gmail.com',
        //     'joel@cristapples.com',
        //     'jroot002@gmail.com',
        //     'jsmcmillion@yahoo.com',
        //     'kellysnide@yahoo.com',
        //     'kle1@cornell.edu',
        //     'kmlewis@wsu.edu',
        //     'kplatte24@att.net',
        //     'kris@woutersfruit.be',
        //     'lc878@cornell.edu',
        //     'lg579@cornell.edu',
        //     'mackenziep@treefruitresearch.com',
        //     'manoella@treefruitresearch.com',
        //     'masonk@msu.edu',
        //     'mblair@abbottfarms.com',
        //     'meganmu@scarletmail.com',
        //     'minards@gmail.com',
        //     'mrb254@cornell.edu',
        //     'mrm67@cornell.edu',
        //     'mtroncoso@gmail.com',
        //     'nickschweitzer@comcast.net',
        //     'pelon180589@gmail.com',
        //     'pf246@cornell.edu',
        //     'pgorchards@hotmail.com',
        //     'ph373@cornell.edu',
        //     'phlyborn@yahoo.com',
        //     'platteda@msu.edu',
        //     'procon@comcast.net',
        //     'proconnor@umass.edu',
        //     'rac2750@hotmail.com',
        //     'robbie@oregonheritagefarm.com',
        //     'rodf12786@aol.com',
        //     'rothwel3@msu.edu',
        //     'rrb3@brownsberrypatch.com',
        //     'rrb3@orcharddale.com',
        //     'samuelsricker@gmail.com',
        //     'sarah@bonniebraefruitfarms.com',
        //     'schwalli@msu.edu',
        //     'stefan-pircher@rolmail.net',
        //     'stephen@dawsonsorchards.com',
        //     'steve@sunorchardapples.com',
        //     'tbaker13@hotmail.com',
        //     'test3@example.com',
        //     'test4@example.com',
        //     'test5@example.com',
        //     'test8@example.com',
        //     'test9@example.com',
        //     'test@example.com',
        //     'tkfamilyfarm@gmail.com',
        //     'tkon17@gmail.com',
        //     'tom@fergsonsorchard.com',
        //     'tomn@squad16.com',
        //     'tory@treefruitresearch.com',
        //     'vgingerich@agrassistance.com',
        //     'wells1898@gmail.com',
        //     'wincowgill@mac.com',
        // ]
        // const rows = []
        // _.each(USERS, (email) => {
        //     db.collection(`locations/${email}/locations`)
        //         .get()
        //         .then((querySnapshot) => {
        //             querySnapshot.forEach((doc) => {
        //                 // doc.data() is never undefined for query doc snapshots
        //                 const data = doc.data()
        //                 if (data.weather_station) {
        //                     rows.push([email, doc.id, data.weather_station.id, data.weather_station.title]);
        //                 }
        //             });
        //         })
        //         .catch((error) => {
        //             console.log("Error getting documents: ", error);
        //         });
        // })
        // console.log(rows)

    }


}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts